<template>
    <div class="hts-distributing__detail-map h-full">
        <hts-map-vehicle
            ref="map"
            :route="route"
            class="h-full"
            :show-location="showLocation"
            center-marker />
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
  journey: Object,
  loading: Boolean,
  showLocation: {
    type: Boolean,
    default: true
  }
})

const { journey, showLocation }: any = toRefs(props)
const route = ref<any>(null)
const map = ref()
const latLngLocationRoutes = ref([] as google.maps.LatLngLiteral[])

watch(
  () => showLocation.value,
  (val) => {
    if (!map.value) {
      return
    }

    if (!val) {
      map.value.removeAdvanceMarkers()

      if (route.value) {
        map.value.renderNodeListInRoute(latLngLocationRoutes.value)
      }
      return
    }

    map.value.renderNodeList()
  }
)

watch(
  () => journey.value,
  (val: any) => {
    renderJourneyRoute(val)
  },
  { deep: true }
)
const renderJourneyRoute = (journey: any) => {
  if (!journey || !journey.stages) {
    return
  }
  const { stages } = journey
  let { startAtLocation, stopAtLocation } = journey
  if (Array.isArray(startAtLocation)) {
    startAtLocation = startAtLocation[0] || null
  }
  if (Array.isArray(stopAtLocation)) {
    stopAtLocation = stopAtLocation[0] || null
  }
  if (!Array.isArray(stages) || stages.length < 2) {
    return
  }
  let originData: google.maps.LatLngLiteral = { lat: 0, lng: 0 }
  let destinationData: google.maps.LatLngLiteral = { lat: 0, lng: 0 }
  let originLocationName = 'A'
  let destinationLocationName = 'B'
  latLngLocationRoutes.value = []
  const waypointsData: { location: google.maps.LatLngLiteral; node?: string; locationName?: string }[] = []
  let hasStart = false
  let hasStop = false
  if (startAtLocation) {
    hasStart = true
    const { locationName } = startAtLocation
    let { lat, lng } = startAtLocation
    lat = parseFloat(lat?.toString())
    lng = parseFloat(lng?.toString())
    originData = { lat, lng } as google.maps.LatLngLiteral
    originLocationName = locationName
    latLngLocationRoutes.value.push({ lat, lng, nodeLocationName: locationName } as google.maps.LatLngLiteral)
  }

  if (stopAtLocation) {
    hasStop = true
    const { locationName } = stopAtLocation
    let { lat, lng } = stopAtLocation
    lat = parseFloat(lat?.toString())
    lng = parseFloat(lng?.toString())
    destinationData = { lat, lng } as google.maps.LatLngLiteral
    destinationLocationName = locationName
    latLngLocationRoutes.value.push({ lat, lng, nodeLocationName: locationName } as google.maps.LatLngLiteral)
  }

  stages.forEach((s: any, i: number) => {
    if (isNaN(s.lat) || isNaN(s.lng)) {
      return
    }
    const lat = parseFloat(s.lat?.toString())
    const lng = parseFloat(s.lng?.toString())
    latLngLocationRoutes.value.push({ lat, lng, nodeLocationName: s.nodeLocationName } as google.maps.LatLngLiteral)

    if (i === 0 && !hasStart) {
      originData = { lat, lng } as google.maps.LatLngLiteral
      originLocationName = s.nodeLocationName
      return
    }
    if (i === stages.length - 1 && !hasStop) {
      destinationData = { lat, lng } as google.maps.LatLngLiteral
      destinationLocationName = s.nodeLocationName
      return
    }

    waypointsData.push({
      location: { lat, lng } as google.maps.LatLngLiteral,
      node: s.node,
      locationName: s.nodeLocationName
    })
  })

  route.value = {
    originData,
    destinationData,
    waypointsData,
    options: {
      originLocationName,
      destinationLocationName,
      sameOriginDestination: originData.lat === destinationData.lat && originData.lng === destinationData.lng
    }
  }
  renderLocationRoute()
}

const renderLocationRoute = () => {
  nextTick(() => {
    if (showLocation.value) {
      return
    }

    if (!latLngLocationRoutes.value || !latLngLocationRoutes.value.length) {
      map.value && map.value.removeAdvanceMarkers()
      return
    }

    map.value && map.value.removeAdvanceMarkers()
    map.value && map.value.renderNodeListInRoute(latLngLocationRoutes.value)
  })
}

onMounted(() => {
  if (journey.value) {
    renderJourneyRoute(journey.value)
  }
})

const setVehicleCenter = (vehicle: any) => {
  map.value && map.value.setCenter(vehicle)
}
defineExpose({ setVehicleCenter })
</script>
